import classNames from 'classnames';
import React__default from 'react';
import { s as styles } from '../url-input-modal-ce9582dc.js';
import ModalCloseButton from '../Components/ModalCloseButton.js';
import { BUTTON_SIZE } from '../consts.js';
import SettingsMobileHeader from '../Components/SettingsMobileHeader.js';
import Button from '../Components/Button.js';
import '../style-inject.es-746bb8ed.js';
import '../Icons/ModalsCloseIcon.js';
import 'wix-rich-content-common';

const TextInputModalContainer = ({
  t,
  languageDir,
  dataHook,
  children,
  title,
  subTitle,
  isMobile,
  withMobileHeader = true,
  withMobileSaveButton = false,
  selected = true,
  showTitle = true,
  onConfirm,
  onCloseRequested,
  saveLabel,
  showCloseButton
}) => {
  const saveLabelText = saveLabel || t("EmbedURL_Common_CTA_Primary");
  const modalTitle = title && showTitle && /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: classNames(styles.input_header_title, {
        [styles.input_header_title_withCloseButton]: showCloseButton
      })
    },
    title,
    showCloseButton && /* @__PURE__ */ React__default.createElement(ModalCloseButton, { closeModal: onCloseRequested })
  );
  const modalSubTitle = subTitle && /* @__PURE__ */ React__default.createElement("div", { className: styles.header_subTitle }, subTitle);
  const renderMobileHeader = () => /* @__PURE__ */ React__default.createElement(
    SettingsMobileHeader,
    {
      onCancel: () => onCloseRequested == null ? void 0 : onCloseRequested(),
      t,
      title: t("EmbedURL_MobileHeader"),
      showSaveBtn: false
    }
  );
  const renderActionButton = () => /* @__PURE__ */ React__default.createElement(
    Button,
    {
      dataHook: "actionButtonSave",
      disabled: !selected,
      onClick: onConfirm,
      size: BUTTON_SIZE.medium
    },
    saveLabelText
  );
  const shouldRenderActionButton = !isMobile || isMobile && withMobileSaveButton;
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: classNames(styles.inputModal_container, {
        [styles.inputModal_mobile]: isMobile,
        [styles.inputModal_mobile_withHeader]: withMobileHeader && isMobile
      })
    },
    isMobile && withMobileHeader && renderMobileHeader(),
    /* @__PURE__ */ React__default.createElement("div", { className: styles.inputModal_content, "data-hook": dataHook, dir: languageDir }, modalTitle, modalSubTitle, /* @__PURE__ */ React__default.createElement(
      "div",
      {
        className: classNames(styles.inputModal_textInput, {
          [styles.textInput_margin_bottom]: withMobileSaveButton
        })
      },
      children
    ), shouldRenderActionButton && renderActionButton())
  );
};

export { TextInputModalContainer as default };
//# sourceMappingURL=TextInputModalContainer.js.map
